<template>
  <FreeBottomSheet :name="name">
    <template #header="{ hide }">
      <FreeHeader class="p-4 text-center" is-centered>
        <template #leftAction>
          <FreeBackButton class="opacity-50" @click="hide" />
        </template>
        <h1 class="font-medium">
          {{ t('ancillaries.medicalInsurance.details.conditionsTitle') }}
        </h1>
        <template #rightAction>
          <FreeCloseButton class="gray-header-close-button" @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div class="space-y-4 whitespace-pre-wrap px-4 pb-4">
        <div class="rounded-2xl bg-white p-4">
          <p>
            {{ t('ancillaries.flightDelay.details.conditionsDescription') }}
          </p>
        </div>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import {
    FreeBottomSheet,
    FreeHeader,
    FreeCloseButton,
    FreeBackButton,
  } from 'freedom-shared';

  defineProps<{
    name: string;
  }>();

  const { t } = useI18n();
</script>
